import * as React from "react";
import { createModalContext } from ".";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Form } from "react-router-dom";
import { Button } from "@/components/ui/button";
import FormState from "@/components/form-state";
import { q } from "@/lib/query";

export interface IDeleteCompanyModalProps {
  closeModal?(triggerCloseEvent?: boolean): void;
  companyId: number;
}

const DESIRED_INPUT_VALUE = "supprimer l'entreprise";
export function DeleteCompanyModal({
  closeModal,
  companyId,
}: IDeleteCompanyModalProps) {
  const [inputValue, setInputValue] = React.useState("");
  return (
    <Dialog open onOpenChange={() => closeModal?.()}>
      <DialogContent className="bg-card border-border text-foreground">
        <DialogHeader>
          <DialogTitle>Supprimer l'entreprise</DialogTitle>
        </DialogHeader>
        <Form action={q("/app/admin/companies?index")} method="DELETE">
          <div className="space-y-4 w-full">
            <p className="px-4 py-2 bg-destructive/40 text-[#ff565f] text-sm leading-6 tracking-wide rounded-md">
              <b>Attention</b> : Cette action est irréversible.
            </p>
            <div className="space-y-2">
              <Label>
                Saisissez <b>supprimer l'entreprise</b> ci-dessous:
              </Label>
              <Input
                name="name"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </div>
            <DialogFooter className="sm:justify-between">
              <Button
                type="submit"
                variant="destructive"
                disabled={inputValue !== DESIRED_INPUT_VALUE}
              >
                Confirmer
              </Button>
              <Button
                type="button"
                className="min-w-[128px]"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  closeModal?.();
                }}
              >
                Annuler
              </Button>
            </DialogFooter>
            <FormState data={{ id: companyId }} />
          </div>
        </Form>
      </DialogContent>
    </Dialog>
  );
}

export const [
  useDeleteCompanyModal,
  DeleteCompanyProvider,
  DeleteCompanyContext,
] = createModalContext(DeleteCompanyModal);
